import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/img-lights.webp'


const _hoisted_1 = { class: "w-web-panel mx-auto max-w-full md:max-w-[95%] bg-[url(@/assets/home/light-bg.webp)] md:bg-none px-8 py-10 md:p-0" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "md:max-w-[420px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold font-georgian text-[22px] md:text-[32px] leading-tight md:leading-normal text-white md:text-green mb-6 max-w-56 md:max-w-max" }, " Perfect Landscape Lighting ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-white md:text-secondary-gray text-sm md:text-base leading-relaxed mb-8 md:mb-20" }, " At Perfect Green, we set the mood you want — whether it’s soft and romantic or cheerfully lit. We can even add a touch of color with warm washes of golden light, adding vibrancy and charm. If your landscaping could talk, it would thank you for making it look so terrific. ", -1)
const _hoisted_6 = {
  href: "#lighting",
  class: "md:hidden"
}
const _hoisted_7 = {
  href: "#lighting",
  class: "hidden md:block"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-[360px] ml-auto hidden md:block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-full"
  })
], -1)

import DefaultButton from "@/components/common/default-button.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'perfect-lights',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("a", _hoisted_6, [
          _createVNode(DefaultButton, {
            color: "white",
            class: "max-w-[315px]"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("a", _hoisted_7, [
          _createVNode(DefaultButton, {
            color: "green",
            class: "max-w-[315px]"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_8
    ])
  ]))
}
}

})